<template>
  <div>
    <modal
      v-if="cancelModalVisible"
      :title="$t('mc.modals.titles.mcCancel')"
      :scroll="false"
      @close="closeModals">
      <template v-slot:body>
        <span class="modal-cancel-text">
          {{$t('mc.manager.modalCancelMk.cancel')}}
        </span>
        <ReasonSelectAndComment
          :rejectionReasons="$store.state.booking.lossReasons"
          @changeReason="changeReason"
          @changeComment="changeComment"
        />
      </template>
      <template v-slot:footer>
        <loader v-if="loadInModal"/>
        <template v-else>
          <button
            class="btn btn_danger btn_autowidth btn_is-margin-right"
            :disabled="!reason"
            @click="saveMkCancel">{{$t('mc.manager.modalCancelMk.buttons.cancel')}}</button>
          <button
            class="btn btn_danger btn_autowidth btn_transparent"
            @click="closeModals">{{$t('mc.manager.modalCancelMk.buttons.close')}}</button>
        </template>
      </template>
    </modal>
    <modal
      v-if="resheduleModalVisible"
      :title="$t('mc.modals.titles.reschedule')"
      :padding="'30px 30px 0px 30px'"
      @close="closeModals"
      width="1200px">
      <template v-slot:body>
        <select-date-mk
          type="reschedule"
          page="list-mk"
          :mkId="reshedule.mkIdForModal"
          :additionalInfoLoad="reshedule.additional_info"
          :reason="reason"
          :comment="comment"
          @close="closeModals">
          <template #reasonAndComment>
            <ReasonSelectAndComment
              :commentPlaceholder="$t('mc.placeholders.reschedule')"
              :rejectionReasons="$store.state.booking.lossReasons"
              @changeReason="changeReason"
              @changeComment="changeComment"
            />
          </template>
        </select-date-mk>
      </template>
    </modal>

    <header-page
      :namePage="$t('pagesTitles.mc')"
      ref="headerPage"
      :links="$store.state.user.segmentM1Distribution ? $store.state.headerLinks.managerMcLinksWithTimetable : $store.state.headerLinks.managerMcLinks"
      :isSearchInput="true"
      @searchByAmoId="searchByAmoId"/>

    <div class="content">
      <loader v-show="loading"/>
      <div v-show="!loading">
        <label class="checkbox hide-finished" @change="toggleFinishedMk" v-if="typePage === 'mc'">
          <input
            type="checkbox"
            class="checkbox-input"
            id="finished"
            v-model="hideFinishedMk">
          <span>
            <inline-svg
              class="checkbox__icon"
              :src="require(`@/assets/svg/checkbox.svg`)"/>
          </span>
          {{$t('mc.manager.hideFinishedMc')}}
        </label>
        <SearchPeriod @searchByDate="searchByDate" />
        <base-table
          :head="[
          $t('mc.tables.titles.client'),
          '',
          $t('mc.tables.titles.date'),
          $t('mc.tables.titles.mimk'),
          $t('mc.tables.titles.phone'),
          $t('mc.tables.titles.status'),
          $t('mc.tables.titles.action'),
          'Zoom',
          $t('mc.tables.titles.link')]"
          :columnTemplates="dynamicColumnSize"
          :sticky="true">
          <base-table-row
            v-for="(element) of allMkWithSubArrays[page - 1]"
            :key="`${element.id}future`"
            :style="bookingsTags && Array.isArray(bookingsTags[element.id]) && bookingsTags[element.id].length ? 'position: relative; padding-bottom: 40px;' : ''"
            :columnTemplates="dynamicColumnSize">
            <base-table-column class="table-column_elipsis">
              <Copy :text="element.amoLink" :textMessage="$t('mc.toasts.copyLink')"/>
              <a class="table-link" :href="element.amoLink" target="_blank">{{element.amoId}}</a>
            </base-table-column>
            <base-table-column>
              <router-link :to="`/master-classes/detail/${element.id}`" target="_blank" v-tooltip="$t('mc.tooltips.detailMc')">
                <inline-svg
                  class="icon-in-mk"
                  :src="require(`@/assets/svg/link.svg`)"/>
              </router-link>
            </base-table-column>
            <base-table-column>
              <span>{{element.date.date}}</span>
              <br>
              <span>{{element.date.time}}</span>
            </base-table-column>
            <base-table-column>
              <span v-tooltip="getMimkTags(element.mimk_id)">{{element.mimk_name}}</span>
            </base-table-column>
            <base-table-column>
              <a
                :href="`https://web.whatsapp.com/send?phone=${element.whatsapp}`">
                {{element.whatsapp}}
              </a>
            </base-table-column>
            <base-table-column>
              <span :class="['table-column-status', {'table-column-status_danger': element.status.name === $store.state.statuses.mcStatuses.cancel}]">
                <inline-svg
                  class="table-column-status__icon"
                  :src="require(`@/assets/svg/${element.status.svg}.svg`)"/>
                {{element.status_translated}}
              </span>
              <span
                v-if="element.hour_before_confirmed"
                class="table-column-status_hour-confirm">{{$t('mc.tables.cols.confirmBeforeHour')}}</span>
            </base-table-column>
            <base-table-column>
              <div v-if="element.typeMk === 'future' || element.typeMk === 'search'" class="table-column-buttons">
                <button
                  class="btn btn_success btn_square"
                  v-tooltip="$t('mc.tooltips.beforeHour')"
                  v-if="!element.hour_before_confirmed && element.status.name !== $store.state.statuses.mcStatuses.cancel"
                  @click="confirmBeforeHour(element.id)">
                  <inline-svg :src="require(`@/assets/svg/button-hour.svg`)"/>
                </button>
                <button
                  class="btn btn_white btn_square"
                  v-tooltip="$t('mc.tooltips.reshedule')"
                  v-if="element.status.name !== $store.state.statuses.mcStatuses.cancel"
                  @click="openModalReshedule(element.id, element.mk_starts_at, element.additional_info)">
                  <inline-svg :src="require(`@/assets/svg/button-reschedule.svg`)"/>
                </button>
                <button
                  class="btn btn_danger btn_square"
                  v-if="element.status.name !== $store.state.statuses.mcStatuses.cancel"
                  v-tooltip="$t('mc.tooltips.cancel')"
                  @click="openModalCancel(element.id)">
                  <inline-svg :src="require(`@/assets/svg/button-cancel.svg`)"/>
                </button>
              </div>
            </base-table-column>
            <base-table-column>
              <div class="zoom-links-wrapper" v-if="element.zoom_start_url || element.zoom_join_url">
                <a
                    v-if="element.zoom_start_url && !isZoomButtonActive(element)"
                    href="javascript:void(0)"
                    class="zoom-start-link zoom-start-link--disabled"
                    v-tooltip="zoomStartUrlTooltip(element)"
                >
                  <inline-svg :height="54" :src="require(`@/assets/svg/zoom-play.svg`)"></inline-svg>
                </a>
                <a
                    v-else-if="element.zoom_start_url"
                    :href="element.zoom_start_url"
                    class="zoom-start-link"
                    target="_blank"
                    v-tooltip="zoomStartUrlTooltip(element)"
                >
                  <inline-svg :height="54" :src="require(`@/assets/svg/zoom-play.svg`)"></inline-svg>
                </a>
                <a
                    href="javascript:void(0)"
                    @click="copyToClipboard(element.zoom_join_url)"
                    class="zoom-join-link"
                    v-tooltip="$t('mc.zoom.copyZoom')"
                >
                  <span>
                    <inline-svg :height="16" :src="require(`@/assets/svg/upload-icon-white.svg`)"></inline-svg>
                  </span>
                </a>
              </div>
            </base-table-column>
            <base-table-column>
              <div v-if="canUseZoomFlags">
                <span
                  v-if="element.zoom_link_in_wa_sent && element.zoom_link_in_wa_sent === true"
                  class="zoom-join-link"
                  v-tooltip="$t('mc.zoom.zoomLinkWaTrue')"
                >
                  <img width="40px" height="40px" :src="require(`@/assets/svg/whatsapp_actiive.svg`)" />
                </span>
                <span
                  v-else
                  class="zoom-join-link"
                  v-tooltip="$t('mc.zoom.zoomLinkWaFalse')"
                >
                  <img width="40px" height="40px" :src="require(`@/assets/svg/whatsapp_not_active.svg`)" />
                </span>
                <span
                  v-if="element.zoom_link_in_mail_sent && element.zoom_link_in_mail_sent === true"
                  class="zoom-join-link"
                  v-tooltip="$t('mc.zoom.zoomLinkMailTrue')"
                >

                  <img width="40px" height="40px" :src="require(`@/assets/svg/mail_active.svg`)" />

                </span>
                <span
                  v-else
                  class="zoom-join-link"
                  v-tooltip="$t('mc.zoom.zoomLinkMailFalse')"
                >

                  <img width="40px" height="40px" :src="require(`@/assets/svg/mail_not_active.svg`)" />

                </span>
              </div>
            </base-table-column>
            <div style="position: absolute;bottom: 0;padding-left: 15px;" v-if="bookingsTags && Array.isArray(bookingsTags[element.id])">
              <Tags :show-title="false" :modify-ability="false" tags-wrapper-style="width: calc(100vw - 400px);" :prop-tags="bookingsTags[element.id]"></Tags>
            </div>
          </base-table-row>
        </base-table>
        <div class="pagination">
          <Count @changeCountsOnPage="changeCountsOnPage"/>
          <pagination
            v-model="page"
            :records="allMk.length"
            :per-page="perPage"
            :options="{texts: false}"
            @paginate = "setPage"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config"
import militaryAndLanguage from "@/helpers/militaryAndLanguage"
import booking from '@/api/master-classes/booking'
import globalSettingCalendar from '@/helpers/globalSettingCalendar'
import createSubarrays from "@/helpers/createSubarrays"
import scrollToContent from "@/helpers/scrollToContent"
import SelectDateMk from "@/components/MK/SelectDateMk.vue"
import ReasonSelectAndComment from "@/components/ReasonSelectAndComment.vue"
import Copy from '@/components/UI/Copy'
import Count from '@/components/UI/CountElementsOnPage'
import SearchPeriod from "@/components/UI/DatePickerPeriod"
import Tags from "@/components/Supervisor/Tags"
import apiTags from "@/api/tags";
import copyToClipboard from "@/helpers/copyToClipboard"
import { isDateTimeInRange } from "@/helpers/commonHelpers";
import { BACKOFFICE } from '@/services/HTTPService'
export default {
  components: {
    SelectDateMk,
    ReasonSelectAndComment,
    Copy,
    Count,
    SearchPeriod,
    Tags,
  },
  data() {
    return {
      globalSettingCalendar,
      militaryAndLanguage,
      isWideScreen: false,
      columnSize: '2fr 16px 2fr 2fr 3fr 2fr 2fr 150px 150px',
      columnSizeNarrow: '2fr 16px 2fr 2fr 3fr 95px 150px 55px 80px',
      searchDateFrom: '',
      searchDateTo: '',
      allMk: [],
      mkFinished: [],
      mkCurrent: [],
      mkFuture: [],
      allMkWithSubArrays: [],
      reason: '',
      comment: '',
      hideFinishedMk: false,
      canUseZoomFlags: false,
      loading: false,
      loadInModal: false,
      page: 1,
      perPage: 10,
      typePage: 'mc', //mc, search
      cancelModalVisible: false,
      resheduleModalVisible: false,
      reshedule: {
        mkIdForModal: '',
        startMkDate: '',
        additional_info: ''
      }
    }
  },
  computed: {
    bookingsTags() {
      return this.$store.state.tags.bookingsTagsObject
    },
    mimksTags() {
      return this.$store.state.tags.mimksTagsObject
    },
    dynamicColumnSize() {
      return this.isWideScreen ? this.columnSize : this.columnSizeNarrow
    },
  },

  async mounted() {
    this.canUseZoomFlags = await this.getSegmentForZoomFlags()
    this.checkScreenWidth() // Проверяем при загрузке
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    isZoomButtonActive(el) {
      return isDateTimeInRange(null, el.zoom_session_starts_at, el.zoom_session_ends_at, this.$store.state.user.segment.tz_offset) &&
          (this.$store.state.user.user.id === el.mimk_id || this.$store.state.user.user.role === 'supervisor' || this.$store.state.user.user.role === 'admin')
    },
    zoomStartUrlTooltip(el) {
      const isZoomButtonActive = this.isZoomButtonActive(el)

      if (isZoomButtonActive) return this.$t('mc.zoom.startZoom')

      const now = this.$dayjs(this.$dayjs(new Date()).utc().add(this.$store.state.user.segment.tz_offset, 'second').format('YYYY-MM-DD HH:mm'))
      const startDate = this.$dayjs(el.zoom_session_starts_at)

      if (now.isBefore(startDate)) return this.$t('mc.zoom.prompt2', [startDate.format('HH:mm')])

      if (el.mimk_id !== this.$store.state.user.user.id && this.$store.state.user.user.role !== 'supervisor' && this.$store.state.user.user.role !== 'admin') {
        return this.$t('mc.zoom.prompt1')
      }

      return this.$t('mc.zoom.prompt3')
    },
    copyToClipboard(text) {
      copyToClipboard(text, () => {
        this.$toasted.global.all_ok(this.$t('mc.toasts.copyLink'));
      });
    },
    getMimkTags(mimkId) {
      if (this.mimksTags && this.mimksTags[mimkId]) {
        return this.mimksTags[mimkId].map(tag => tag.name).join(', ')
      }

      return null
    },
    async searchByDate({ start, finish }) {
      this.loading = true;
      this.searchDateFrom = start;
      this.searchDateTo = finish;
      await this.loadMasterClasses(this.searchDateFrom, this.searchDateTo)
      this.loading = false;
    },
    disabledFilterTo(date) {
      return date < new Date(this.$dayjs(this.searchDate, 'DD.MM.YYYY').valueOf())
    },
    setPage() {
      scrollToContent(this.$el.querySelector('.content'))
    },
    async changeCountsOnPage(value) {
      this.perPage = value
      await this.loadMasterClasses(this.searchDateFrom, this.searchDateTo)
    },

    async getSegmentForZoomFlags() {
      try {
        const response = await BACKOFFICE.get(`/segments/${this.$store.state.user.segment.id}/`);
        return response.data.use_sending_zoom_links;
      } catch (e) {
        console.error(e);
        return false;
      }
    },

    async loadMasterClasses(date, dateTo, amoSearch) {
      const isMilitaryTime = this.militaryAndLanguage()
      this.loading = true
      this.allMk = []

      const MK = class {
        constructor(object, dayjs, typeMk) {
          this.object = object
          this.dayjs = dayjs
          this.typeMk = typeMk
        }

        returnObject() {
          return this.object.map(el => {
            let svgName = 'status-wait'
            if (el.status === 'Отменен') svgName = 'status-cancel'
            if (el.status === 'Завершен') svgName = 'status-complete'
            return {
              id: el.id,
              amoLink: `${config.AMO_LINK}${el.amocrm_id}`,
              amoId: el.amocrm_id,
              mk_starts_at: el.mk_starts_at,
              additional_info: el.additional_info,
              date: {
                date: this.dayjs(el.mk_starts_at, 'YYYY-MM-DD HH:mm').format('DD.MM.YYYY'),
                time: isMilitaryTime ? this.dayjs(el.mk_starts_at, 'YYYY-MM-DD HH:mm').format('HH:mm') : this.dayjs(el.mk_starts_at, 'YYYY-MM-DD HH:mm').format('hh:mm a'),
              },
              parent: el.parent_name,
              whatsapp: el.parent_whatsapp,
              status: {
                svg: svgName,
                name: el.status,
                canceled: el.status === 'Отменен'
              },
              zoom_start_url: el.zoom_start_url,
              zoom_join_url: el.zoom_join_url,
              zoom_link_in_wa_sent: el.zoom_link_in_wa_sent,
              zoom_link_in_mail_sent: el.zoom_link_in_mail_sent,
              status_translated: el.status_translated,
              hour_before_confirmed: el.hour_before_confirmed,
              typeMk: this.typeMk,
              mimk_name: el.mimk_name ? el.mimk_name : '__',
              mimk_id: el.mimk,
              zoom_session_starts_at: el.zoom_session_starts_at,
              zoom_session_ends_at: el.zoom_session_ends_at,
            }
          })
        }
      }

      let masterClasses
      if (amoSearch) {
        let searchResult = await booking.getMkByLink(amoSearch)
        masterClasses = [...searchResult.current, ...searchResult.finished, ...searchResult.future]
        const searchTable = new MK(masterClasses, this.$dayjs, 'search').returnObject()
        this.allMk = [...searchTable]
      } else {
        console.log(dateTo);
        masterClasses = await booking.getBookingsAll(this.$dayjs(date, 'DD.MM.YYYY').format('YYYY-MM-DD') + ' 00:00', this.$dayjs(dateTo, 'DD.MM.YYYY').format('YYYY-MM-DD') + ' 00:00')
        this.mkFinished = new MK(masterClasses.finished, this.$dayjs, 'finished').returnObject()
        this.mkFuture = new MK(masterClasses.future, this.$dayjs, 'future').returnObject()
        this.mkCurrent = new MK(masterClasses.current, this.$dayjs, 'current').returnObject()
        this.allMk = [...this.mkFinished, ...this.mkCurrent, ...this.mkFuture]
        this.hideFinishedMk = JSON.parse(localStorage.getItem('hideFinishedMkM1Page'))
        this.toggleFinishedMk()
      }

      const bookingIds = this.allMk.map(booking => booking.id)
      const mimkIds = this.allMk.map(booking => booking.mimk_id)

      if (bookingIds.length) apiTags.getBookingsTags(bookingIds, true)
      if (mimkIds.length) apiTags.getMimksTags(mimkIds, this.$store.state.user.segment.id, true)

      this.allMkWithSubArrays = createSubarrays(this.perPage, this.allMk)
      this.loading = false
    },
    toggleFinishedMk() {
      if (this.hideFinishedMk === true) {
        this.allMk.splice(0, this.mkFinished.length)
        localStorage.setItem('hideFinishedMkM1Page', true);
      } else {
        this.allMk = [...this.mkFinished, ...this.mkCurrent, ...this.mkFuture]
        localStorage.setItem('hideFinishedMkM1Page', false);
      }
      this.allMkWithSubArrays = createSubarrays(this.perPage, this.allMk)
      this.page = 1
    },
    openModalCancel(id) {
      this.reshedule.mkIdForModal = id
      this.cancelModalVisible = true
    },
    openModalReshedule(id, startMkDate, additional_info) {
      this.reshedule.mkIdForModal = id
      this.reshedule.startMkDate = startMkDate
      this.reshedule.additional_info = additional_info
      this.resheduleModalVisible = true
    },
    async closeModals(value) {
      this.reshedule.mkIdForModal = ''
      this.reshedule.startMkDate = ''
      this.reshedule.additional_info = ''
      this.cancelModalVisible = false
      this.resheduleModalVisible = false
      this.loadInModal = false
      this.reason = false
      if (value === 'reschedule') {
        await this.loadMasterClasses(this.searchDateFrom, this.searchDateTo)
      }
    },
    changeReason(reason) {
      this.reason = reason.actual
    },
    changeComment(comment) {
      this.comment = comment
    },
    changeCallDate(value) {
      this.reshedule.callDate = value
    },
    async saveMkCancel() {
      this.loadInModal = true
      const isCommentExist = !!this.comment
      const transmittedQueryParams = isCommentExist ?
        `loss_reason=${this.reason}&comment=${this.comment}` :
        `loss_reason=${this.reason}`
      await booking.removeBooking(
        this.reshedule.mkIdForModal,
        transmittedQueryParams
      ).then(async() => {
        this.closeModals()
        this.$toasted.global.all_ok(this.$t('mc.toasts.mcCanceled'))
        await this.loadMasterClasses(this.searchDateFrom, this.searchDateTo)
      }).catch(() => {
        this.loadInModal = false
      })
    },
    async confirmBeforeHour(id) {
      const confirm = await booking.updateBooking(id, {hour_before_confirmed:true})
      if (confirm) {
        const idx = this.allMk.findIndex(el => el.id === id)
        this.allMk[idx].hour_before_confirmed = true
        this.allMkWithSubArrays = createSubarrays(this.perPage, this.allMk)
        this.$toasted.global.all_ok(this.$t('mc.toasts.mcConfirmed'))
      }
    },
    async searchByAmoId(value) {
      if (value.length) {
        this.typePage = 'search'
        this.loadMasterClasses(false, false, value)
      } else {
        this.typePage = 'mc'
        this.loadMasterClasses(this.searchDateFrom, this.searchDateTo)
      }
    },
    checkScreenWidth() {
      this.isWideScreen = window.innerWidth >= 1800
    },
    handleResize() {
      this.checkScreenWidth()
    }
  },
  async created() {
    this.searchDateFrom = this.$dayjs(new Date()).format('DD.MM.YYYY')
    this.searchDateTo = this.$dayjs(new Date()).format('DD.MM.YYYY')
    if (!localStorage.getItem('countsOnPage')) {
      this.perPage = 10
    } else {
      this.perPage = JSON.parse(localStorage.getItem('countsOnPage')).value
    }
  },
  watch: {
    // async searchDateFrom(date) {
    //   //Чистим поисковую строку и строим таблицу
    //   this.$refs.headerPage.clearAmoId()
    //   await this.loadMasterClasses(date)
    // }
  }
}
</script>

<style lang="scss" scoped>
.notice {
  display: block;
  margin: 16px 0;
}
.hide-finished {
  margin-bottom: 20px;
}
.modal {
  &-cancel {
    &-text {
      display: block;
      margin-bottom: 20px;
    }
  }
  &-reshedule {
    &-text {
      display: block;
      margin: 20px 0;
    }
    &-time {
      margin-top: 24px;
      margin-bottom: 20px;
      width: 100px;
    }
  }
}

.datepicker_mimk {
  margin-right: 10px;
}

.datepicker-content {
  &__label {
    margin-right: 10px;
  }
}
</style>
